/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProcessingModals_organization$ref: FragmentReference;
declare export opaque type ProcessingModals_organization$fragmentType: ProcessingModals_organization$ref;
export type ProcessingModals_organization = {|
  +databaseId: string,
  +$refType: ProcessingModals_organization$ref,
|};
export type ProcessingModals_organization$data = ProcessingModals_organization;
export type ProcessingModals_organization$key = {
  +$data?: ProcessingModals_organization$data,
  +$fragmentRefs: ProcessingModals_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProcessingModals_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '7e2f1e69acf068cd7014f70bce3f519f';

module.exports = node;
